import "../../App.css"
import { Sidebar, WatchLaterContainer } from "../components"

export const WatchLater = () => {
    return (
        <div className="main-container">
            <Sidebar />
            <WatchLaterContainer />
        </div>

    )
}
